import { Button, Checkbox, CircularProgress, DialogActions, FormControlLabel, TextField } from "@mui/material";
import Alert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import { useState } from "react";
import { requestSegmentstoSrtformat } from "../../utils/export-srt";

const ModalDownloadSrt = ({ open, setOpen, project }) => {

  const [loading, setLoading] = useState(false);
  //console.log("loading",loading);
  const [format, setFormat] = useState('srt');
  const [statusdownload, setStatusdownload] = useState("");
  const [openToast, setOpenToast] = useState(false);
  const [useVideoStartTime, setUseVideoStartTime] = useState(false);
  const [videoStartTime, setVideoStartTime] = useState({
    hours: "",
    minutes: "",
    seconds: "",
  });

  const handleTimeChange = (field, maxValue) => (event) => {
    const value = event.target.value;

    if (value === "") {
      setVideoStartTime((currentTime) => ({
        ...currentTime,
        [field]: "",
      }));
      return;
    }

    const parsedValue = Number(value);

    if (!Number.isFinite(parsedValue)) {
      return;
    }

    const numericValue = Math.floor(Math.max(0, Math.min(parsedValue, maxValue)));
    setVideoStartTime((currentTime) => ({
      ...currentTime,
      [field]: String(numericValue),
    }));
  };

  const getVideoStartOffset = () => {
    if (!useVideoStartTime) {
      return 0;
    }

    const hours = Number(videoStartTime.hours) || 0;
    const minutes = Number(videoStartTime.minutes) || 0;
    const seconds = Number(videoStartTime.seconds) || 0;

    return hours * 3600 + minutes * 60 + seconds;
  };

  const handleDownload = async () => {
    try {
      setLoading(true);
      await requestSegmentstoSrtformat(project, format, getVideoStartOffset());
      setStatusdownload(true);
      setOpenToast(true);
    } catch (error) {
      setStatusdownload(false);
      setOpenToast(true);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };
  return (
    <>
      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={() => setOpenToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={statusdownload ? "success" : "error"}>
          {statusdownload ? "File downloaded successfully" : "Error downloading file"}
        </Alert>
      </Snackbar>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "white", backgroundColor: "#28262E" }}
        >
          Select download format
        </DialogTitle>
        <DialogActions
          sx={{
            color: "white",
            backgroundColor: "#28262E",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: 3,
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              <div style={{ display: 'flex', gap: 2 }}>
                <Button
                  onClick={() => setFormat('srt')}
                  variant={format === 'srt' ? 'contained' : 'outlined'}
                  sx={{ color: "white", borderColor: "white" }}
                >
                  SRT
                </Button>
                <Button
                  onClick={() => setFormat('docx')}
                  variant={format === 'docx' ? 'contained' : 'outlined'}
                  sx={{ color: "white", borderColor: "white" }}
                >
                  DOCX
                </Button>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 12, width: "100%" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={useVideoStartTime}
                      onChange={(event) => setUseVideoStartTime(event.target.checked)}
                      sx={{ color: "white", "&.Mui-checked": { color: "#8EC36A" } }}
                    />
                  }
                  label="Video start time"
                  sx={{ color: "white", margin: 0 }}
                />
                <div style={{ display: "flex", gap: 12, width: "100%" }}>
                  <TextField
                    disabled={!useVideoStartTime}
                    label="Hours"
                    type="number"
                    value={videoStartTime.hours}
                    onChange={handleTimeChange("hours", 99)}
                    inputProps={{ min: 0 }}
                    size="small"
                    sx={{
                      width: 110,
                      input: { color: "white" },
                      label: { color: "white" },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "white" },
                        "&:hover fieldset": { borderColor: "white" },
                        "&.Mui-focused fieldset": { borderColor: "#8EC36A" },
                      },
                      "& .Mui-disabled": {
                        color: "rgba(255, 255, 255, 0.7)",
                        WebkitTextFillColor: "rgba(255, 255, 255, 0.7)",
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "rgba(255, 255, 255, 0.7)",
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
                        borderColor: "rgba(255, 255, 255, 0.45)",
                      },
                    }}
                  />
                  <TextField
                    disabled={!useVideoStartTime}
                    label="Minutes"
                    type="number"
                    value={videoStartTime.minutes}
                    onChange={handleTimeChange("minutes", 59)}
                    inputProps={{ min: 0, max: 59 }}
                    size="small"
                    sx={{
                      width: 110,
                      input: { color: "white" },
                      label: { color: "white" },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "white" },
                        "&:hover fieldset": { borderColor: "white" },
                        "&.Mui-focused fieldset": { borderColor: "#8EC36A" },
                      },
                      "& .Mui-disabled": {
                        color: "rgba(255, 255, 255, 0.7)",
                        WebkitTextFillColor: "rgba(255, 255, 255, 0.7)",
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "rgba(255, 255, 255, 0.7)",
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
                        borderColor: "rgba(255, 255, 255, 0.45)",
                      },
                    }}
                  />
                  <TextField
                    disabled={!useVideoStartTime}
                    label="Seconds"
                    type="number"
                    value={videoStartTime.seconds}
                    onChange={handleTimeChange("seconds", 59)}
                    inputProps={{ min: 0, max: 59 }}
                    size="small"
                    sx={{
                      width: 110,
                      input: { color: "white" },
                      label: { color: "white" },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "white" },
                        "&:hover fieldset": { borderColor: "white" },
                        "&.Mui-focused fieldset": { borderColor: "#8EC36A" },
                      },
                      "& .Mui-disabled": {
                        color: "rgba(255, 255, 255, 0.7)",
                        WebkitTextFillColor: "rgba(255, 255, 255, 0.7)",
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "rgba(255, 255, 255, 0.7)",
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
                        borderColor: "rgba(255, 255, 255, 0.45)",
                      },
                    }}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: 2 }}>
                <Button
                  onClick={() => setOpen(false)}
                  sx={{ color: "white", backgroundColor: "#952937" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleDownload}
                  autoFocus
                  sx={{ color: "white", backgroundColor: "#8EC36A" }}
                >
                  Download
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalDownloadSrt;
